import React, {useEffect, useState, useContext} from 'react';
import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import Backdrop from '@mui/material/Backdrop';
import Box from '@mui/material/Box';
import Modal from '@mui/material/Modal';
import Fade from '@mui/material/Fade';
import Typography from '@mui/material/Typography';
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import './CreateOrganization.css';
import { AuthContext } from '../../../../AuthContext';

import { createNewOrganisation } from '../../../../apis/organisations.api';

function CreateOrganization({
  openCreateOrganization, 
  setOpenCreateOrganization, 
  setIsToastOpen, 
  setToastMessage, 
  setLoading, 
  setErrorCode
 }) {
  const queryClient = useQueryClient();
  const {authData} = useContext(AuthContext)
  const {access_token, token_type} = authData
  const [formValues, setFormValues] = useState(
    {
      "name": "",
      "org_admin_id": 0,
      "org_new_admin": {
        "name": "",
        "email": "",
        "password": ""
      }
    }
  )

  const handleAdminNameChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      org_new_admin: {
        ...prevValues.org_new_admin,
        name: e.target.value
      }
    }));
  };

  const handleAdminEmailChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      org_new_admin: {
        ...prevValues.org_new_admin,
        email: e.target.value
      }
    }));
  };

  const handleAdminPasswordChange = (e) => {
    setFormValues((prevValues) => ({
      ...prevValues,
      org_new_admin: {
        ...prevValues.org_new_admin,
        password: e.target.value
      }
    }));
  };

  const mutation = useMutation({
    mutationFn : createNewOrganisation,
    onSuccess: (res) => {
      queryClient.invalidateQueries('organisations')
      setToastMessage("Organisation has been created successfully");
      setErrorCode(res?.status);
      setLoading(false);
      setIsToastOpen(true);
    },
    onError: (error) => {
      setLoading(false);
      const errorMessage = error.response?.data?.detail || error.message || 'Unknown error';
      setToastMessage(`Error: ${errorMessage}`);
      setErrorCode(error?.response?.status);
      setIsToastOpen(true);
    }
  })

  const createOrganisation = async () => {
    setLoading(true);
    setOpenCreateOrganization(false);
    mutation.mutate({org: formValues, access_token, token_type});
  };

  const createOrganisationFormSubmit = (e) => {
    e.preventDefault();
    createOrganisation();
  }
  
  return (
    <>
        <Modal
        aria-labelledby="transition-modal-title"
        aria-describedby="transition-modal-description"
        open={openCreateOrganization}
        onClose={()=>setOpenCreateOrganization(false)}
        closeAfterTransition
        slots={{ backdrop: Backdrop }}
        slotProps={{
          backdrop: {
            timeout: 500,
          },
        }}
        className="createOrganizationModal"
      >
        <Fade in={openCreateOrganization}>
          <Box className="createOrganizationModalClass">
            <div className="createOrganizationModalHeader">
              <Typography
                id="transition-modal-title"
                variant="h6"
                component="h2"
                className="createOrganizationModalTitle"
              >
                Create Organization
              </Typography>
              <span
                className="createOrganizationModalClose"
                onClick={()=>setOpenCreateOrganization(false)}
              >
                &times;
              </span>
            </div>
            <form
                className="g-3"
                onSubmit={(e) => createOrganisationFormSubmit(e)}
              >
                <div className="createOrganizationModalBody">
                    <div className="d-flex" style={{margin:'16px 0', position:'relative'}}>
                        <div className="col-6" style={{paddingRight:'12px'}}>
                            <label htmlFor="org-name" className="form-label">
                              Organization Name<span style={{color: 'red'}}>&#65290;</span>
                            </label>
                            <TextField
                                required
                                id="org-name"
                                placeholder="organization name"
                                sx={{width: "100%"}}
                                onChange={(e) => setFormValues({...formValues,name: e.target.value})}
                            />
                        </div>
                    </div>
                    <div className='superAdminTitle'>Super Admin</div>
                    <div className="d-flex" style={{marginTop:'24px', marginBottom:'24px', position:'relative'}}>
                        <div className="col-6" style={{paddingRight:'12px'}}>
                            <label htmlFor="admin-name" className="form-label">
                              Admin Name<span style={{color: 'red'}}>&#65290;</span>
                            </label>
                            <TextField
                                required
                                id="admin-name"
                                placeholder="admin name"
                                sx={{
                                width: "100%",
                                }}
                                onChange={handleAdminNameChange}
                            />
                        </div>
                        <div className="col-6" style={{paddingLeft:'12px'}}>
                            <label htmlFor="email-id" className="form-label">
                              Email ID<span style={{color: 'red'}}>&#65290;</span>
                            </label>
                            <TextField
                                required
                                id="email-id"
                                placeholder="email id"
                                sx={{
                                    width: "100%",
                                }}
                                onChange={handleAdminEmailChange}
                            />
                        </div>
                    </div>
                    <div className="d-flex" style={{marginTop:'24px', marginBottom:'24px', position:'relative'}}>
                        <div className="col-6" style={{paddingRight:'12px'}}>
                            <label htmlFor="password" className="form-label">
                              Password<span style={{color: 'red'}}>&#65290;</span>
                            </label>
                            <TextField
                                required
                                id="password"
                                placeholder="password"
                                sx={{
                                width: "100%",
                                }}
                                onChange={handleAdminPasswordChange}
                            />
                        </div>
                    </div>
                </div>
                <div className="createOrganizationFormButtons">
                    <Button variant="outlined" size="large" onClick={()=>setOpenCreateOrganization(false)}>
                      Cancel
                    </Button>
                    <Button variant="contained" size="large" type="submit">Create</Button>
                </div>
            </form>
          </Box>
        </Fade>
      </Modal>
    </>
  );
}

export default CreateOrganization;